import * as React from "react";

import { $api } from "./client";
import type { components } from "./schema";

export type Location = components["schemas"]["Location"];

/** All locations: bounded reference data, unpaginated. Pass `search` for
 *  server-side filtering when wiring a typeahead/combobox. */
export const useLocations = (query: { search?: string } = {}) =>
  $api.useQuery(
    "get",
    "/api/v1/locations/",
    { params: { query } },
    { staleTime: 5 * 60 * 1000 },
  );

export function useLocationName(): (id: number | null | undefined) => string {
  const { data } = useLocations();
  return React.useCallback(
    (id) => data?.find((l) => l.id === id)?.name ?? "",
    [data],
  );
}
